<template>
	<v-text-field v-model="search" class="py-0 my-0" :color="nocolor == false ? 'background' : ''" append-icon="fas fa-search" :label="$t('global.search')" single-line hide-details @click:append="LaunchSearch()" @change="LaunchSearch()" @click:clear="LaunchSearch(true)" clearable :autofocus="autofocus" @input="debouncedMethods"></v-text-field>
</template>

<script>
export default {
	data: () => ({
		search: null,
		innerValue: null,
		debouncedMethods: null,
	}),
	props: {
		value: {
			type: String,
			default: null,
		},
		autofocus: Boolean,
		nocolor: Boolean,
	},
	methods: {
		LaunchSearch(reset) {
			if (reset) {
				this.innerValue = null;
			} else {
				if (this.search != this.innerValue) {
					this.innerValue = _.cloneDeep(this.search);
				}
			}
		},
		DebounceSearch() {
			this.LaunchSearch();
		},
	},
	watch: {
		innerValue(newVal) {
			this.$emit("input", newVal);
			this.$nextTick(() => {
				this.$emit("change");
			});
		},
		value(newVal) {
			this.innerValue = _.cloneDeep(newVal);
		},
	},
	created() {
		if (this.value) {
			this.innerValue = _.cloneDeep(this.value);
		}
		const self = this;
		this.debouncedMethods = _.debounce(function () {
			self.DebounceSearch();
		}, self.$appOptions.debounceTime());
	},
	beforeDestroy() {
		this.$emit("input", null);
		this.innerValue = null;
	},
};
</script>
